export default __webpack_public_path__ + "static/media/logo_prd.b1d49709.jpg";